(ns cms.core
  (:require
    [cms.config]
    
    [clojure.string :as str]
    [cemerick.url :refer [url]]
    
    [cms.editor :as editor]
    
    [reagent.core :as r]
    [reagent.dom :as dom]
    
    [reitit.frontend :as rf]
    [reitit.frontend.easy :as rfe]
    
    [firebase.core :as fb]
    [firebase.storage :as storage]
    [firebase.auth :as auth]
    [firebase.functions :as funcs :refer-macros [defcallable]]
    
    [promises.core :refer-macros [await->
                                  await-let]]))

;; --- Application state -------------------------------------
(defonce current-route& (r/atom nil))
(defonce current-user&  (r/atom nil))

;; --- Pages -------------------------------------------------        
(defn home-page []
  [:h2 "Home"])

(defonce edit-state& (r/atom {:url nil :data nil :stored nil}))

(.addEventListener js/window "beforeunload"
  (fn [e]
    (when (not= (:data @edit-state&)
                (:stored @edit-state&))
      (set! (.-returnValue e) "You have unsaved changes. Are you sure you want to leave?")
      "You have unsaved changes. Are you sure you want to leave?")))

(defn edit-page [props route]
  (let [path (get-in route [:path-params (keyword "")])]
    (println "reload edit-page")
    [editor/view {} path edit-state&]))

;; --- Router ------------------------------------------------
(def router
  (rf/router
    [["/edit/*" {:name :edit :view edit-page}]]))

(defn on-navigate [new-match]
  (let [hash (.-hash js/location)]
    (reset! current-route& (assoc new-match :hash hash))))

(defn app []
  (let [route @current-route&
        view  (get-in route [:data :view] home-page)
        hash  (:hash route)]
    [:<>
     [:div#top-bar 
      [:img {:src "img/musopia-logo-white-1.svg"}]
      [:h1 "Content Management"]
      (if-not @current-user&
        [:button {:on-click #(auth/sign-in-with-google :popup)} 
         "Sign in with Goog"]
        [:button {:on-click #(auth/sign-out)}
          "Sign out"])]
     [:div.page 
      [view {} route]]
     (when 
       (-> route :parameters :query :debug-route)
       [:code (pr-str route)])]))


;; --- Initialize ------------------------------------------
(defonce track-user (auth/track-current-user! current-user&))

(defn mount-root []
  (dom/render [app] 
              (.getElementById js/document "app")))

(defn ^:export ^:dev/after-load init []
  ;; Start frontend router
  (rfe/start!
    router
    (partial reset! current-route&)
    {:use-fragment true})
  ;; Mount Reagent app
  (mount-root))